import { notificationStatuses, notificationStates, notificationKinds, roles, noStates} from './../../helpers/trans'
import React from 'react';
import Header from './../Header';
import Footer from './../Footer'
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import {rightDate} from './../../helpers/pdf';
import { getNotification, getReply, submitReply, submitIngoingNumber, logout, getAttachments} from './../../actions/actions'
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Link, Redirect } from 'react-router-dom';
import Toolbar from  '@material-ui/core/Toolbar';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import MenuItem from  '@material-ui/core/MenuItem';

export const APPROVED = 'APPROVED';
export const DECLINED = 'DECLINED';
export const reply_types = [
    {value: 'REGISTRATION', title:'о получении уведомления и регистрации объекта строительства'},
    {value: 'ENROLLMENT', title:'о принятии объекта строительства на учет'}
]

export const attributes =  {
    building_object_registration_date: 'Дата регистрации',
    building_object_registration_number:'Регистрационный номер объекта',
    reply_number:'Номер исходящего извещения',
    comment_text:'Текст комментария',
    reply_type:'Тип извещения',
    file: 'Прикрепить файл'
}

const styles = theme => ({
    root: {
        width: '100%',
        gridColumnStart: 2,
        gridColumnEnd: 4,
    },
    contentWrapper: {
        display: 'grid',
        gridTemplateColumns: '1fr 4fr 4fr 1fr'
    },
    container_registration: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: 20,
        width: '100%'
    },
    button: {
        marginTop: theme.spacing.unit,
        marginBottom:theme.spacing.unit,
        fontFamily: 'PT Sans Narrow',
        fontSize: '15px',
        borderRadius: 0,
        boxShadow: 'none',
        color: '#fff',
        backgroundColor: '#76b5b8'
    },

    buttonLeft:{
        marginTop: theme.spacing.unit,
        marginBottom:theme.spacing.unit*3,
        fontFamily: 'PT Sans Narrow',
        fontSize: '15px',
        borderRadius: 0,
        boxShadow: 'none',
        float: 'left',
        color: '#fff',
        backgroundColor: '#76b5b8',
    },
    headerStatic:{
        margin: '60px 0',
        fontSize: 26,
        fontFamily:'PT Sans Narrow, sans-serif',
        fontWeight: 'bold'
    },
    textStatic:{
        margin: '60px 0',
        maxWidth: '65%',
        color: '#5b5b5b'
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: '60px'
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    dense: {
        marginTop: 16,
    },
    menu: {
        width: 200,
    },
    h5: {
        color:'#76b5b8',
        fontSize: 22,
        fontFamily:'PT Sans Narrow, sans-serif',
        fontWeight: 100
    },
    rootFlex: {
        display: 'flex',
        width: '50%',
        color: '#76b5b8',
    },
    wrapperButton:{
        width: '50%',
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    newColor: {
        color:'#76b5b8',
        borderBottom: '2px solid #76b5b8',
        '&::after':{
            borderBottom: '2px solid #76b5b8'
        },
        "&:hover":{
            border: 'none'
        },
        '&::before': {
            borderColor: ''
        }
    },
    label: {
        color: '#76b5b8 !important',
    },
    input: {
        '&::after':{
            borderBottom: '1px solid #76b5b8'
        },
        "&:hover":{
            borderBottom: '1px solid rgba(189, 235, 255, 0.8)'
        },
        '&::before': {
            borderBottom: '1px solid rgba(189, 235, 255, 0.6) !important'
        }
    },
    tabRoot: {
        textTransform: 'none'
    },
    tabLabel: {
        color:'#76b5b8',
        fontSize: 22,
        fontFamily:'PT Sans Narrow, sans-serif',
        fontWeight: 100
    },
    appBar: {
        width: '50%',
        backgroundColor: 'transparent',
        boxShadow: 'none'
    },
    indicator:{
        backgroundColor: '#76b5b8',
    }
});

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 2 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
};


export class NotificationCard extends React.Component {
    constructor(props) {
        super(props)
        this.state =  {
            auth:false,
            user:{},
            value: 0,
            status:'new',
            reply_status_form: {
                ingoing_number:''
            },
            no:{},
            reply_form: {
                status: 'APPROVED',
                building_object_registration_date: '',
                building_object_registration_number:'',
                reply_number:'',
                comment_text:'',
                reply_type:'',
                file: ''
            }
        }
    }

    logout = () => {
        this.props.logout();
        this.setState({auth:false, user:{}});
    }

    componentWillMount() {
        let user = JSON.parse(localStorage.getItem('user'));
        if (
            user.role.indexOf(roles.ROLE_SUPERVISOR)>=0 ||
            user.role.indexOf(roles.ROLE_INSPECTOR_MANAGER)>=0 ||
            user.role.indexOf(roles.ROLE_INSPECTOR_REPLIES)>=0 ||
            user.role.indexOf(roles.ROLE_INSPECTOR_RECEIVE)>=0 ||
            user.role.indexOf(roles.ROLE_INSPECTOR_MAIN)>=0 ||
            user.role.indexOf(roles.ROLE_SUPER_ADMIN)>=0
        ) {
            this.props.getNotification(this.props.match.params.id);
            this.props.getReply(this.props.match.params.id, user.token);
            this.props.getAttachments(user.token, this.props.match.params.id);
            this.setState({auth:true, user: user});
        }
    }

    componentWillReceiveProps(nextProps){
        console.log(nextProps);
        if('no' in nextProps) {
            console.log('updated');
            this.setState({no: nextProps.no})
        }
    }

    handleChange = (event, value) => {
        let data = {status: value === 0 ? APPROVED : DECLINED }
        let currentData = this.state.reply_form;
        console.log(value);
        this.setState({value, reply_form: {...currentData, ...data}});
    };

    onSelect = event => {
        this.setState({ reply_form: { ...this.state.reply_form, ...{ inspection_id: event.target.value } } });
    }
    handleSubmit = () => {
        console.log(this.state.reply_form);
        this.props.submitReply(this.state.reply_form, this.props.match.params.id, this.state.user.token);
        this.setState({status: 'submited'});
    }
    updateInput = input => {
        let data = {[input.name]: input.value};
        let currentData = this.state.reply_form;
        this.setState({ reply_form: {...currentData, ...data}});
    };
    updateIngoingNumber = input => {
        this.setState({ reply_status_form: {ingoing_number: input.value}});
    };
    
    submitIngoingNumber = () => {
        this.props.submitIngoingNumber(this.state.reply_status_form.ingoing_number, this.props.match.params.id, this.state.user.token);
    }
    
    handleSelect = event => {
        let data = { [event.target.name]: event.target.value } ;
        let currentData = this.state.reply_form;
        this.setState({ reply_form:{ ...currentData, ...data}});
        console.log(this.state.reply_form);
    };


    render () {
        if (this.state.auth == false) {
            return (<Redirect to="/login"/>)
        }
         let {no, item, classes} = this.props;

        if (no.decision_index == null) {no.decision_index = ''};
        if (no.developer_agreement_number == null) {no.developer_agreement_number=''};
        if (no.project_manager_name == null) { no.project_manager_name = ''};
        if (no.project_manager_position == null) { no.project_manager_position = ''};
        if (no.project_manager_phone == null) { no.project_manager_phone = ''};
        if (no.order_index == null ) { no.order_index = ''};
        if ( no.object_city == null ) { no.object_city = ''};
        if ( no.object_street == null ) {no.object_street  = ''};
        if ( no.object_block == null ) { no.object_block = ''};
        if ( no.object_building == null ) { no.object_building = ''};
        if ( no.object_address_approximate == null ) { no.object_address_approximate = ''};
        if ( no.decision_org_name == null ) {no.decision_org_name = ''};
        if ( no.decision_index == null ) {  no.decision_index = ''};
        if ( no.project_manager_name == null ) { no.project_manager_name = ''};
        if ( no.project_manager_position == null ) {no.project_manager_position = ''};
        if ( no.project_manager_phone == null ) { no.project_manager_phone = ''};
        if ( no.order_index == null ) { no.order_index = ''};
        if ( no.design_company_city == null ) { no.design_company_city = ''};
        if ( no.design_company_street == null ) { no.design_company_street = ''};
        if ( no.design_company_phone == null ) { no.design_company_phone = ''};
        if ( no.developer_city == null ) { no.developer_city = ''};
        if ( no.developer_street == null ) { no.developer_street = ''};
        if ( no.developer_conformity_certificate_number == null ){ no.developer_conformity_certificate_number = ''};
        if ( no.supervision_city == null ) { no.supervision_city = ''};
        if ( no.supervision_street == null ) { no.supervision_street = ''};
        if ( no.author_supervision_city == null ) {  no.author_supervision_city = ''};
        if ( no.author_supervision_street == null) { no.author_supervision_street = ''};

        if ( no.project_manager_position == null ) {no.project_manager_position = ''};
        if ( no.developer_term == null ) {no.developer_term = ''};
        if ( no.author_supervision_phone == null ) { no.author_supervision_phone = ''};
        if ( no.author_supervision_complexity_class == null) {no.author_supervision_complexity_class = ''};
        if ( no.payment_order_index == null) { no.payment_order_index = ''}
        if ( no.client_org_conformity_certificate_index == null) { no.client_org_conformity_certificate_index = ''}
        if ( no.developer_phone == null ) { no.developer_phone = ''}
        if ( no.certificate_category == null ) { no.certificate_category  = ''}
        if ( no.expertise_resolution_index == null ) { no.expertise_resolution_index = ''}
        if ( no.responsible_org_agreement_number == null) { no.responsible_org_agreement_number = ''}
        if ( no.responsible_org_phone == null) { no.responsible_org_phone = ''}
        if ( no.supervision_certificate_category == null ) { no.supervision_certificate_category = ''}
        if ( no.supervision_phone == null ) { no.supervision_phone = ''}
        if ( no.supervision_certificate_number == null) { no.supervision_certificate_number = ''}


        no.author_supervision_state = (no.author_supervision_state == null || no.author_supervision_state.length == 0) ? '' : `${no.author_supervision_state}`;
          no.author_supervision_region = (no.author_supervision_region == null || no.author_supervision_region.length == 0) ? '' : `${no.author_supervision_region}`; 
         no.supervision_state = (no.supervision_state == null || no.supervision_state.length == 0) ? '' : `${no.supervision_state}, `; 
         no.supervision_region = (no.supervision_region == null || no.supervision_region.length == 0) ? '' : `${no.supervision_region}, `; 
         no.developer_state = (no.developer_state == null || no.developer_state.length == 0) ? '' : `${no.developer_state}, `;
         no.developer_region =  (no.developer_region == null || no.developer_region.length == 0) ? '' : `${no.developer_region}, `;
         no.design_company_state = (no.design_company_state == null || no.design_company_state.length == 0) ? '' : `${no.design_company_state}`; 
         no.design_company_region = (no.design_company_region == null || no.design_company_region.length == 0) ? '' : `${no.design_company_region}`;
         no.client_org_state = (no.client_org_state == null || no.client_org_state.length == 0) ? '' : `${no.client_org_state}`;
         no.client_org_region = (no.client_org_region == null || no.client_org_region.length == 0) ? '' : `${no.client_org_region}`; 
         no.registered_inspection_name = (no.registered_inspection_name == null || no.registered_inspection_name.length == 0) ? '' : `${no.registered_inspection_name}`; 
         no.inspection_name = (no.inspection_name == null || no.inspection_name.length == 0) ? '' : `${no.inspection_name}, `; no.object_city =  (no.object_city == null || no.object_city.length == 0) ? '' : `${no.object_city}`;
          no.object_street = (no.object_street == null || no.object_street.length == 0) ? '' : `${no.object_street}, `; 
         no.object_block = (no.object_block == null || no.object_block.length == 0) ? '' : `${no.object_block}, `; 
         no.object_building = (no.object_building == null || no.object_building.length == 0) ? '' : `, корп. ${no.object_building}, `;
         no.object_address_approximate = (no.object_address_approximate == null || no.object_address_approximate.length == 0) ? '' : `${no.object_address_approximate}, `;
         no.other_sources_budget = (no.other_sources_budget == null || no.other_sources_budget.length == 0) ? '0,00' : `${no.other_sources_budget.toLocaleString('ru-RU', {minimumFractionDigits: 2})} рублей`;

        no.state_budget = (no.state_budget == null || no.state_budget.length == 0) ? '0,00' : `${no.state_budget.toLocaleString('ru-RU', {minimumFractionDigits: 2})}`;

        no.estimated_budget = (no.estimated_budget == null || no.estimated_budget.length == 0) ? '0,00' : `${no.estimated_budget.toLocaleString('ru-RU', {minimumFractionDigits: 2})}`;

        no.earmarked_contributions = (no.earmarked_contributions == null || no.earmarked_contributions.length == 0) ? '0,00' : `${no.earmarked_contributions.toLocaleString('ru-RU', {minimumFractionDigits: 2})}`;

        let client_org_certificate_date  =  (no.client_org_certificate_date == null || no.client_org_certificate_date == '') ? '' : `, от ${rightDate(no.client_org_certificate_date)}, `;
        
         const {value, user} = this.state;
         let froze = (no.state >=20);
         console.log(froze);
         return(
         <div>
             {this.state.user.role.indexOf(roles.ROLE_SUPERVISOR)>=0 &&(<Header link={{to:'/supervision/', title: this.state.user.org}} />)}
             {(this.state.user.role.indexOf(roles.ROLE_INSPECTOR_RECEIVE)>=0 || this.state.user.role.indexOf(roles.ROLE_INSPECTOR_MANAGER)>=0 || this.state.user.role.indexOf(roles.ROLE_INSPECTOR_MAIN)>=0 || this.state.user.role.indexOf(roles.ROLE_INSPECTOR_REPLIES)>=0) &&(<Header link={{to:'/inspection/', title: this.state.user.org}} />)}
             {this.state.user.role.indexOf(roles.ROLE_SUPER_ADMIN)>=0 && (<Header link={{to:'/admin/', title: this.state.user.org}} />)}
             {(this.state.user.role.indexOf(roles.ROLE_SUPER_ADMIN)>=0) && (
                 <Toolbar>
                     <Button component={Link} to="/admin/">Вернуться</Button>
                     <Button onClick={this.logout}>Выйти</Button>
                 </Toolbar>)}
             {(this.state.user.role.indexOf(roles.ROLE_SUPERVISOR)>=0) && (
                 <Toolbar>
                     <Button component={Link} to="/inspection/">Вернуться</Button>
                     <Button onClick={this.logout}>Выйти</Button>
                 </Toolbar>)}
             {(this.state.user.role.indexOf(roles.ROLE_INSPECTOR_RECEIVE)>=0 || this.state.user.role.indexOf(roles.ROLE_INSPECTOR_MANAGER)>=0 || this.state.user.role.indexOf(roles.ROLE_INSPECTOR_MAIN)>=0 || this.state.user.role.indexOf(roles.ROLE_INSPECTOR_REPLIES)>=0) && (
                 <Toolbar>
                     <Button component={Link} to="/supervision/">Вернуться</Button>
                     <Button onClick={this.logout}>Выйти</Button>
                 </Toolbar>)}
         <ExpansionPanel>
             <ExpansionPanelSummary>УВЕДОМЛЕНИЕ</ExpansionPanelSummary>
             <ExpansionPanelDetails>
                 <Typography paragraph>
                 <Typography variant="h6" align="center">{no.inspection_name}</Typography>
                 <Typography variant="h6" align="center">УВЕДОМЛЕНИЕ</Typography>
                 <Typography variant="h6" align="center">Исходящий номер {no.outgoing_number}</Typography>
                 <Typography variant="h6" align="center"> {notificationKinds[no.kind]}  </Typography>
                 <Typography component="p">{no.client_org_name},</Typography>
                 <Typography component="p">{no.client_org_country}, {no.client_org_state}{no.client_org_region}{no.client_org_city}{no.client_org_street}, тел. {no.client_org_phone}, </Typography>
                 <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>(Наименование юридического лица (фамилия, собственное имя, отчество (если таковое имеется)
                 </Typography>
                 <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>индивидуального предпринимателя), направляющего уведомление, место нахождения (место жительства), номер телефона)
                 </Typography>
                 <Typography component="p">{no.client_tax_comp_name}, ОКПО {no.client_org_okpo}, УНН {no.client_org_unn}, аттестат соответствия  {no.client_org_conformity_certificate_index} {client_org_certificate_date}


                 </Typography>
                 <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>(наименование инспекции Министерства по налогам и сборам, учетный номер плательщика,
                 </Typography>
                 <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>номер аттестата соответствия с указанием категории)
                 </Typography>
                 <Typography gutterBottom paragraph>направляет настоящее уведомление о том, что на объекте строительства
                 </Typography>
                 <Typography gutterBottom paragraph>{no.object_name}, {no.object_country}, {no.object_state}, {no.object_region}, {no.object_city}, {no.object_street}, {no.object_block} {no.object_building} {no.object_address_approximate} {no.object_address_lon} {no.object_address_lat}.
                 </Typography>
                 <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>(наименование объекта согласно разрешительной документации, выданной местным исполнительным и распорядительным органом (за исключением объектов капитального ремонта), или согласно утвержденной проектной документации по объекту капитального ремонта, адрес)
                 </Typography>
                 <Typography gutterBottom paragraph>с {rightDate(no.start_date)} будет начато производство строительно-монтажных работ.
                 </Typography>
                 <Typography gutterBottom paragraph>Строительство осуществляется на основании решения {no.decision_org_name}, от {rightDate(no.decision_date)}, № {no.decision_index}.
                 </Typography>
                 <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>(наименование местного исполнительного и распорядительного органа)
             </Typography>
             <Typography gutterBottom paragraph>Руководителем (управляющим) проекта назначен {no.project_manager_name}, {no.project_manager_position}, приказ {no. order_index} от {rightDate(no.order_date)}, тел. {no.project_manager_phone}
             </Typography>
             <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>(фамилия, собственное имя, отчество (если таковое имеется), должность, номер и дата приказа, номер телефона) </Typography>


                     <Typography component="p"> Проектная документация разработана {no.design_company_name},
                </Typography>
             <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>(наименование юридического лица (фамилия, собственное имя, отчество (если таковое имеется) индивидуального предпринимателя),
                 </Typography>



                     <Typography gutterBottom paragraph>{no.design_company_country}, {no.design_company_state}{no.design_company_region}{no.design_company_city}, {no.design_company_street}, тел. {no.design_company_phone},
             </Typography>
             <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>место нахождения (место жительства), номер телефона)
             </Typography>
             <Typography gutterBottom paragraph>утверждена приказом (распоряжением) {no.client_org_name} от {rightDate(no.design_approval_order_date)}.
             </Typography>
             <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>(наименование юридического лица (фамилия, собственное имя, отчество (если таковое имеется) индивидуального предпринимателя), утвердившего документацию, дата)
             </Typography>


                     <Typography gutterBottom paragraph>Заключение государственной экспертизы {no.state_expertise_org_name} от {rightDate(no.expertise_resolution_date)}, № {no.expertise_resolution_index}.
             </Typography>
             <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>(наименование органа государственной экспертизы)
             </Typography>
             <Typography gutterBottom paragraph>Строительно-монтажные работы будут выполняться {no.developer_name},
             </Typography>
             <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>(наименование юридического лица (фамилия, собственное имя, отчество (если таковое имеется) инд ивидуального предпринимателя),
             </Typography>
             <Typography gutterBottom paragraph>{no.developer_country}, {no.developer_state}{no.developer_region} {no.developer_city}, {no.design_company_street}, аттестат соответствия {no.certificate_category} категории № {no.developer_conformity_certificate_number}, тел. {no.developer_phone}
             </Typography>
             <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>место нахождения (место жительства), номер аттестата соответствия с указанием категории, номер телефона)
             </Typography>
             <Typography gutterBottom paragraph>по договору от {rightDate(no.developer_agreement_date)} № {no.developer_agreement_number}.
             </Typography>
             <Typography component="p">Дата начала строительства по договору строительного подряда {rightDate(no.developer_start)} нормативный срок строительства объекта {no.developer_term} месяцев.
             </Typography>

             <Typography component="p">Лицом, ответственным за производство работ на объекте строительства, назначен {no.responsible_org_name}, {no.responsible_org_position}, приказ {no.responsible_org_agreement_number} от {rightDate(no.responsible_org_agreement_date)}, тел. {no.responsible_org_phone}.
             </Typography>
             <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>(фамилия, собственное имя, отчество (если таковое имеется), должность, номер и дата приказа, номер телефона)
             </Typography>
             <Typography component="p">Юридическое лицо или индивидуальный предприниматель, осуществляющие технический надзор (юридическое лицо или индивидуальный предприниматель, осуществляющие комплексное управление строительной деятельностью, в случае заключения соответствующего договора), {no.supervision_name},
             </Typography>
             <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>(наименование юридического лица (фамилия, собственное имя, отчество (если таковое имеется) индивидуального предпринимателя),
             </Typography>
             <Typography component="p">{no.supervision_country}, {no.supervision_state}{no.supervision_region}{no.supervision_city}, {no.supervision_street}, аттестат соответствия {no.supervision_certificate_category} категории № {no.supervision_certificate_number}, тел. {no.supervision_phone}
             </Typography>
             <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>место нахождения (место жительства), номер аттестата соответствия с указанием категории, номер телефон)
             </Typography>
             <Typography gutterBottom paragraph>Юридическое лицо или индивидуальный предприниматель, осуществляющие авторский надзор, {no.author_supervision_name},
             </Typography>
             <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>(наименование юридического лица (фамилия, собственное имя, отчество (если таковое имеется) индивидуального предпринимателя),
             </Typography>

             <Typography gutterBottom paragraph>{no.author_supervision_country}, {no.author_supervision_state}, {no.author_supervision_region}, {no.author_supervision_city}, {no.author_supervision_street}, тел. {no.author_supervision_phone}.
             </Typography>
             <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>место нахождения (место жительства), номер телефона)
             </Typography>
             <Typography gutterBottom paragraph>Класс сложности объекта {no.author_supervision_complexity_class}.
             </Typography>

             <Typography gutterBottom paragraph>Стоимость строительно-монтажных работ согласно сводному сметному расчету (в случаях отсутствия сводного сметного расчета – согласно договорной (контрактной) цене) {no.estimated_budget} рублей, в том числе за счет республиканского и (или) местного бюджета  {no.state_budget !== null ? no.state_budget : 0} рублей, за счет иных источников {no.other_sources_budget}.
             </Typography>
             <Typography gutterBottom paragraph>Перечисление целевых отчислений от {rightDate(no.payment_order_date)},  №  {no.payment_order_index} на сумму {no.earmarked_contributions} рублей.
             </Typography>
             <Typography component="p">{no.description}</Typography>
             <Typography gutterBottom component="p" style={{ fontSize: '8', color: '#777777'}}>(номер и дата платежных поручений,  сумма (рублей)</Typography>
             <Typography gutterBottom component="p">Руководитель юридического лица</Typography>
             <Typography gutterBottom component="p">или уполномоченное лицо</Typography>
             <Typography gutterBottom component="p">(индивидуальный предприниматель)</Typography>
             <Typography component="p">{no.submitted_at} {no.submitted_by_name}.</Typography>

             <Typography component="p" style={{ fontSize: '8', color: '#777777'}}>(подпись)	(фамилия, инициалы)</Typography>


                 {this.props.attachments.length > 0 && (<Typography component="p"  style={{margin: '20px',fontSize:  '1.2em'}}>Документы:</Typography> )}
                 {this.props.attachments.length > 0 && (this.props.attachments.map(item => (
                     <Typography component="p" style={{margin: '20px'}}>
                         <a href={`/uploads/files/${item.file_name}`} target='_blank'>{item.file_name.replace(/^.*[\\\/]/, '')}</a>
                     </Typography>
                 )))}




                     {parseInt(no.state) < 15
                     && (
                         user.role.indexOf(roles.ROLE_INSPECTOR_RECEIVE)>=0 ||
                         user.role.indexOf(roles.ROLE_INSPECTOR_MAIN)>=0 ||
                         user.role.indexOf(roles.ROLE_SUPER_ADMIN)>=0 ||
                         user.role.indexOf(roles.ROLE_SUPERVISOR)>=0
                     ) &&(<form>
                 <TextField
                     required
                     name="ingoing_number"
                     onChange={e => this.updateIngoingNumber(e.target)}
                     id="ingoing_number"
                     label="Входящий номер уведомления"
                     value={this.state.reply_form.ingoing_number}
                     fullWidth
                     className={classes.textField} classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                     InputProps={{className: classes.input}} InputLabelProps={{shrink: true,className: classes.label}}
                 />
                 <Button variant="contained" color="#76b5b8" size="large"
                         className={classes.button}
                         onClick={this.submitIngoingNumber}>
                     Отправить
                 </Button>
                 
             </form>)}
                     {parseInt(no.state) >= 15 &&(<Typography paragraph>Входящий номер уведомления{no.ingoing_number}</Typography>)}
            
            
             </Typography>
             </ExpansionPanelDetails>
         </ExpansionPanel>
             <Typography paragraph style={{ margin:'2em'}}>
             </Typography>
              {parseInt(no.state) >= 15 &&(<Typography style={{ margin:'2em'}} paragraph variant="h6">Входящий номер уведомления {no.ingoing_number}</Typography>)}

              { froze == false && (<div>
                      {((parseInt(no.state) >= 15) && (
                          user.role.indexOf(roles.ROLE_INSPECTOR_REPLIES)>=0 ||
                          user.role.indexOf(roles.ROLE_INSPECTOR_MAIN)>=0 ||
                          user.role.indexOf(roles.ROLE_SUPER_ADMIN)>=0 ||
                          user.role.indexOf(roles.ROLE_SUPERVISOR)>=0
                      )) && (
              <Typography component="div">
             <AppBar position="static" classes={{root: classes.appBar}}>
                 <Tabs
                     value={this.state.value}
                     onChange={this.handleChange}
                     indicatorColor="primary"
                     textColor="primary"
                     fullWidth
                     classes={{indicator: classes.indicator}}
                 >
                     <Tab className={classes.h5} classes={{root: classes.tabRoot, label: classes.tabLabel}} label="Отправить извещение" />
                     <Tab className={classes.h5} classes={{root: classes.tabRoot, label: classes.tabLabel}} label="Отправить отказ" />
                 </Tabs>
             </AppBar>

                <TabContainer>
             <form>
                 {value === 0 &&
                 (<div><TextField
                                id="reply_type"
                                select
                                name="reply_type"
                                label={attributes.reply_type}
                                style={{ margin: 8 }}
                                value={this.state.reply_form.reply_type}
                                onChange={this.handleSelect}
                                fullWidth
                                margin="normal"
                                SelectProps={{
            MenuProps: {
              className: classes.menu,
            },
          }}
                         //helperText="Please select your currency"
                                margin="normal"
                     >
                         {reply_types.map(option => (
                             <MenuItem key={option.value} value={option.value}>
                                 {option.title}
                             </MenuItem>
                         ))}
                     </TextField>



                     <TextField
                     required
                     name="building_object_registration_number"
                     onChange={e => this.updateInput(e.target)}
                     id="building_object_registration_number"
                     label={ attributes.building_object_registration_number}
                     value={this.state.reply_form.building_object_registration_number}
                     fullWidth
                     margin="normal"
                     className={classes.textField}
                     classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                     InputProps={{
                                        className: classes.input
                                      }}
                     InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                 />
                 < TextField
                     required
                     type="date"
                     name="building_object_registration_date"
                     onChange={e => this.updateInput(e.target)}
                     id="building_object_registration_date"
                     label={attributes.building_object_registration_date}
                     value={this.state.reply_form.building_object_registration_date}
                     fullWidth
                     margin="normal"
                     className={classes.textField}
                     classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                     InputProps={{
                     className: classes.input
                 }}
                     InputLabelProps={{
                     shrink: true,
                     className: classes.label
                 }}
                     />
                     <TextField
                     required
                     name="reply_number"
                     onChange={e => this.updateInput(e.target)}
                     id="reply_number"
                     label={attributes.reply_number}
                     value={this.state.reply_form.reply_number}
                     fullWidth
                     margin="normal"
                     className={classes.textField}
                     classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                     InputProps={{
                     className: classes.input
                 }}
                     InputLabelProps={{
                     shrink: true,
                     className: classes.label
                 }}
                     /></div>)
                 }
                 <TextField
                     required
                     name="comment_text"
                     onChange={e => this.updateInput(e.target)}
                     id="comment_text"
                     label={attributes.comment_text}
                     value={this.state.reply_form.comment_text}
                     fullWidth
                     margin="normal"
                     className={classes.textField}
                     classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                     InputProps={{className: classes.input}}
                     InputLabelProps={{shrink: true,className: classes.label}}
                 />
                 {/*<TextField
                     required
                     type="file"
                     name="file"
                     onChange={e => this.updateInput(e.target)}
                     id="comment_text"
                     label={attributes.file}
                     value={this.state.reply_form.file}
                     fullWidth
                     margin="normal"
                     className={classes.textField}
                     classes={{root: classes.rootFlex, underline: classes.newColor, filled:classes.newColor,}}
                     InputProps={{
                                        className: classes.input
                                      }}
                     InputLabelProps={{
                                        shrink: true,
                                        className: classes.label
                                      }}
                 />  */}
                 <Button variant="contained" color="#76b5b8" size="large"
                         className={classes.button}
                         onClick={this.handleSubmit}>
                     Отправить
                 </Button>
             </form>
            </TabContainer>
              </Typography>
                          )}

                 </div>)}

                 <div style={{padding:'3em'}}>
                     <div>{`Статус: `}{noStates[no.state]}</div>
                     <div>{`Текст комментария: `}{item.comment_text}</div>
                     <div>{`Файл: `}  <a href={no.draft_url}>Открыть</a></div>
                     <div>{`Файл с ЭЦП: `} <a href={no.signed_url}>Открыть</a></div>
                     {/*<div>{`Файл вложения`}:-</div> */}
                 </div>
             <Footer />  
         </div>
         )
    }

}

NotificationCard.defaultProps = {
    classes:{},
    no: {
        kind:'',
        inspection_name:'',
        client_org_name:'',
        client_org_country:'',
        client_org_state:'',
        client_org_region:'',
        client_org_city:'',
        client_org_street:'',
        client_org_phone:'',
        client_tax_comp_name:'',
        client_org_okpo:'',
        client_org_unn:'',
        client_org_conformity_certificate_index:'',
        client_org_certificate_date:'',
        object_name:'',
        object_country:'',
        object_state:'',
        object_region:'',
        object_city:'',
        object_street:'',
        object_block:'',
        object_building:'',
        object_address_approximate:'',
        object_address_lon:'',
        object_address_lat:'',
        org_id:'',
        renew_start_date:'',
        start_date:'',
        decision_org_name:'',
        decision_date:'',
        decision_index:'',
        project_manager_name:'',
        project_manager_position:'',
        project_manager_phone:'',
        order_index:'',
        order_date:'',
        design_company_name:'',
        design_company_country:'',
        design_company_state:'',
        design_company_region:'',
        design_company_city:'',
        design_company_street:'',
        design_company_phone:'',
        design_approval_company_name:'',
        design_approval_order_date:'',
        state_expertise_org_name:'',
        expertise_resolution_date:'',
        expertise_resolution_index:'',
        developer_name:'',
        developer_country:'',
        developer_state:'',
        developer_region:'',
        developer_city:'',
        developer_street:'',
        developer_phone:'',
        developer_conformity_certificate_number:'',
        certificate_category:'',
        developer_agreement_number :'',
        developer_agreement_date:'',
        responsible_org_name:'',
        responsible_org_position:'',
        responsible_org_phone:'',
        responsible_org_agreement_number:'',
        responsible_org_agreement_date:'',
        supervision_name:'',
        supervision_country:'',
        supervision_state:'',
        supervision_region:'',
        supervision_city:'',
        supervision_street:'',
        supervision_phone:'',
        supervision_certificate_number:'',
        supervision_certificate_category:'',
        author_supervision_name:'',
        author_supervision_country:'',
        author_supervision_state:'',
        author_supervision_region:'',
        author_supervision_city:'',
        author_supervision_street:'',
        author_supervision_phone:'',
        author_supervision_complexity_class:'',
        estimated_budget:'',
        state_budget:'',
        other_sources_budget:'',
        earmarked_contributions:'',
        payment_order_index:'',
        payment_order_date:'',
        attachments: []
    }

}


export const NotificationCardWithStyles = withStyles(styles)(NotificationCard);
function select(state, props) {
    const { inspector, notifications } = state;
    console.log('SELECT');
    console.log(inspector);
    if (typeof inspector !== "undefined") {
        return {
            no: ('notification' in inspector) ? inspector.notification : {},
            status: ('status' in inspector) ? inspector.status : 'new',
            message: ('message' in inspector) ? inspector.message : '',
            item: ('item' in inspector) ? inspector.item: {} ,
            attachments: ('attachments' in notifications) ? notifications.attachments : []
        };
    } else {
        return {
            no: {},
            status: 'new',
            item: {},
            attachments: []
        }
    }
}

function mapDispatch(dispatch) {
    return {
        submitReply: bindActionCreators(submitReply, dispatch),
        getReply: bindActionCreators(getReply, dispatch),
        getNotification: bindActionCreators(getNotification, dispatch),
        submitIngoingNumber: bindActionCreators(submitIngoingNumber, dispatch),
        logout: bindActionCreators(logout, dispatch),
        getAttachments: bindActionCreators(getAttachments, dispatch)
    };
}

export default connect(select, mapDispatch)(NotificationCardWithStyles);



// WEBPACK FOOTER //
// ./assets/src/js/components/pages/NotificationCard.jsx